import * as React from 'react';
import { system_notification } from 'src/store/slice/system';
import store from 'src/storeWire';
import { useBOMStore } from "../../../../hooks/bom";
import BOM from "@system/config/bom";
import System from "../../../../helper/system";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import Constants from "src/support/Constants";

const BomListingAction = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { sourceOfBOM } = Constants;
    const bomId = System.getParams().bomId
    const [{ bom_detail_by_bom_id_type }, { }, { copy_bom_by_bom_id }] = useBOMStore();

    return (
        <>
            <div className="col-sm-6 mt-3 mt-sm-0">
                <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-1 mb-sm-0 mt-2">
                    {__check('BOM_SAVE_PREFERENCE_API_CALL', 'BOM_TAB_API_CALL', { inline: true }).render}
                    {!__check(['BOM_SAVE_PREFERENCE_API_CALL', 'BOM_TAB_API_CALL']).status &&
                        <>
                            <li className="ms-0 ms-sm-3"><a
                                onClick={() => {
                                    store.dispatch(system_notification({
                                        name: 'DownloadBomPopup',
                                        data: {
                                            isEmailPopup: 'yes'
                                        },
                                    }));
                                }}><i className="fa fa-envelope me-2 text-black" aria-hidden="true"></i> Email</a></li>

                            
                                <li className="ms-3">
                                    <a className={bom_detail_by_bom_id_type && Object.entries(bom_detail_by_bom_id_type).length > 0 &&
                                        bom_detail_by_bom_id_type.totalMatches < 201 ? "" : "disabled-link"}
                                        onClick={() => {
                                            store.dispatch(system_notification({
                                                name: 'DownloadBomPopup',
                                                data: [],
                                            }));
                                        }}><i className="fa fa-download me-2 text-black"></i>Download</a>
                                </li>
                            

                            <li className="ms-3"><a
                                href={void (0)}
                                onClick={async () => {
                                    let res = await copy_bom_by_bom_id({ bomId, source: sourceOfBOM.BOMLIST });
                                    let bomLink = document.createElement('a');
                                    bomLink.href = BOM.getBomRouteURL();
                                    bomLink.click();
                                }}
                            ><i className="copy-icon font-14 me-2  text-black"></i>Create Copy</a></li>
                        </>
                    }

                </ul>
            </div>
        </>
    );
}

export default BomListingAction;